import 'rc-slider/assets/index.css';
import React, { useState, useMemo } from 'react';
import { IRange } from '../../../models/range.model';
import { Range } from 'rc-slider';
import { LOT_FRONTAGE_RANGE_MIN, LOT_FRONTAGE_RANGE_MAX, LOT_FRONTAGE_RANGE_STEP, LOT_FRONTAGE_RANGE_ULTD } from '../../../util/listing-search.constants';
import { formatNumber } from '../../../util/format-number';
import { rangeHighToString } from '../../../util/range-high-to-string';
import { iconFrontage } from '../../../util/icons';

export interface LotFrontageRangeProps {
  lotFrontageRangeLow: number;
  lotFrontageRangeHigh: number;
  setSearchOption(key: string, value: string | number): void;
}

export const LotFrontageRange: React.FC<LotFrontageRangeProps> = props => {
  const [lotFrontageRange, setLotFrontageRange] = useState<IRange>({ low: props.lotFrontageRangeLow, high: props.lotFrontageRangeHigh });

  const onAfterChange = (value: number[]) => {
    props.setSearchOption('lotFrontageRangeLow', value[0]);
    props.setSearchOption('lotFrontageRangeHigh', lotFrontageRange.high === LOT_FRONTAGE_RANGE_ULTD ? 0 : value[1]);
  };

  const onChange = (value: number[]) => {
    setLotFrontageRange({ low: value[0], high: value[1] });
  };

  const rangeLow = useMemo(() => formatNumber(lotFrontageRange.low), [lotFrontageRange.low]);

  const rangeHigh = useMemo(() => rangeHighToString(lotFrontageRange.high, LOT_FRONTAGE_RANGE_MAX, false, formatNumber(lotFrontageRange.high)), [lotFrontageRange.high]);

  return (
    <div className="form-field">
      <div className="form-field-label"><span className="icon">{iconFrontage}</span> <span>Lot Frontage (</span>
        <span>{rangeLow}</span>
        <span> - </span>
        <span>{rangeHigh}</span>
        <span> Feet)</span>
      </div>
      <div className="range-slider">
        <Range
          min={LOT_FRONTAGE_RANGE_MIN}
          max={LOT_FRONTAGE_RANGE_ULTD}
          step={LOT_FRONTAGE_RANGE_STEP}
          defaultValue={[lotFrontageRange.low, lotFrontageRange.high]}
          onChange={onChange}
          onAfterChange={onAfterChange}
          allowCross={false}
          pushable={LOT_FRONTAGE_RANGE_STEP}
        />
      </div>
    </div>
  );
}
